import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/calculator-tariff/:projectGuid/calculations';

export const getPath = (projectGuid: string) => `/calculator-tariff/${projectGuid}/calculations`;

const PageProjectCalculations: React.FC = () => {
  const Page = Loadable.Map({
    loader: {
      page: () => import('./page'),
    },
    loading: LoadableLoading,
    render(loaded) {
      const Component = loaded.page.default;

      return <Component />;
    },
  });

  return <Page />;
};

export default PageProjectCalculations;
